import jsonata from "jsonata";
import { useMemo } from "react";
import jsonataFunctions from "./jsonataFunctions";
import { concatenatePaths, getObject, parseRelPath, CUSTOM_PATHS } from "./mapObject";


class Jnx {
    constructor(jnx){
        if (Array.isArray(jnx) || typeof jnx === "string" || typeof jnx === "number" || typeof jnx === "boolean"){
            jnx = { expr: jnx, scope: '$.' };
        }

        this.expression = Array.isArray(jnx.expr) ? jnx.expr.join("\n") : `${jnx.expr}`;
        this.fn = jsonata(this.expression);
        this.scope = jnx.scope;

        this.scope = parseRelPath(this.scope);

        this.bindFunctions(jsonataFunctions);
    }

    bindFunctions(functionBinds){
        Object.entries(functionBinds || {}).forEach(([name, fn]) => {
            this.fn.registerFunction(name, fn, fn.signature || undefined);
        });
    }

    eval(data, path='', bindings=null, promised=false){
        let context = data;
        const evalBindings = {...(bindings || { })};
        evalBindings.path = path;
        evalBindings.rootData = data;
        if(this.scope !== '$.'){
            const newPath = concatenatePaths(path, this.scope);
            context = getObject(data, newPath);
            evalBindings.path = newPath;
        }

        if (promised) {
            return new Promise((resolve, reject) => {
                this.fn.evaluate(context, evalBindings, (error, result) => {
                    if (error) {
                        reject(error);
                    } else {
                        resolve(result);
                    }
                })
            });
        } else {
            return this.fn.evaluate(context, evalBindings);
        }
    }

    evalAsync(data, path='', bindings=null){
        return this.eval(data, path, bindings, true);
    }
}


export function useJnx(expression, options, fndeps){
    const {
        fn,
        functionBinds
    } = options && (typeof(options) === 'function') ? {fn : options} : (options || {});

    const stableFn = useMemo(() => fn, [...(fndeps || [])]);

    return useMemo(() => {
        const jnx = expression ? new Jnx(expression) : null
        if (jnx) {
            jnx.bindFunctions(functionBinds);
        }
        return stableFn && jnx ? (...args) => stableFn(args, jnx) : jnx;
    }, [expression, stableFn, functionBinds]);
}


CUSTOM_PATHS.expr = {
    parse(mapKey){
        return { type: 'expr', expr: new Jnx(mapKey.expr) };
    },
    resolve(pv, pk, object, initialObject, context){
        return pv.expr.eval(object, '', {
            pv,
            pk,
            context,
            initialObject
        });
    }
}


export default Jnx;